import { S1PythonCommand } from "./s1-pythoncommand.enum";
import { S1PythonModel } from "./s1-pythonmodel";

export class ExecPythonModelRequest {
    command: S1PythonCommand;
    s1PythonModel: S1PythonModel;
}